<template>
  <section class="accomplishment-section">
    <b-container :class="{ verified, loading }">
      <template v-if="certificateDetails !== null">
        <div class="title-wrapper">
          <div class="title">
            <h5>Quiz Certificate</h5>
          </div>
          <div class="sub-title">
            <h3>{{ certificateDetails.lessonName }}</h3>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="left-content">
            <div class="completion-card">
              <div class="card-content-wrapper">
                <div class="avatar">
                  <img
                    :src="require('@/assets/img/logo.svg')"
                    alt="Coinaholic's Logo"
                  />
                </div>
                <div class="content">
                  <div>
                    <h1>
                      Completed by <b>{{ certificateDetails.user.name }}</b>
                    </h1>
                  </div>
                  <div class="date">
                    <div>
                      <b>{{ certificateDetails.issuedDate | date }}</b>
                    </div>
                  </div>
                  <p class="description">
                    {{ certificateDetails.user.name }}'s account is verified.
                    Coinaholic certifies their successful completion of
                    <a
                      target="_blank"
                      :href="`${appRedirectLink}classroomcategory/${certificateDetails.lessonSlug}`"
                      >{{ certificateDetails.lessonName }}</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="right-content">
            <img
              :src="`https://api.classroom.concinnitylimited.com/${certificateDetails.certificate}`"
              class="certification-img"
              alt="certificate"
            />
          </div>
        </div>
      </template>
      <template v-if="loading === true && verified === false">
        <div class="loading d-flex align-items-center justify-content-center">
          <spinner />
        </div>
      </template>
      <template v-if="loading === false && verified === false">
        <div class="loading d-flex align-items-center justify-content-center">
          <b-card body-class="d-flex flex-column align-items-center">
            <p class="h3 mb-1"><b-icon-exclamation-triangle-fill /></p>
            <div class="">Credential Id doesn't match.</div>
          </b-card>
        </div>
      </template>
    </b-container>
  </section>
</template>

<script>
import Spinner from "../components/Spinner.vue";
import { CertificateService } from "../data/services/certificate.service";
export default {
  components: { Spinner },
  name: "Accomplishment",
  filters: {
    date(value) {
      const _date = new Date(value);
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      return new Intl.DateTimeFormat("en-Us", options).format(_date);
    },
  },
  data() {
    return {
      loading: true,
      verified: false,
      certificateDetails: null,
      appRedirectLink: process.env.VUE_APP_ROOT_LINK,
    };
  },
  computed: {
    certificateId() {
      return this.$route.params.certificateId;
    },
  },
  mounted() {
    this.verifyCertificate();
  },
  methods: {
    async verifyCertificate() {
      const certService = new CertificateService();
      const certificate = await certService
        .verify(this.certificateId)
        .catch((error) => {
          console.log({ error });
        });

      if (certificate !== undefined) {
        this.certificateDetails = certificate;
        this.verified = true;
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.accomplishment-section {
  margin: 20px 0;
  position: relative;
  @media screen and (min-width: 1200px) {
    min-height: calc(100vh - 88px - 422px);
  }

  .loading {
    height: 100%;
    min-height: calc(100vh - 88px - 422px);
  }

  .title-wrapper {
    margin-bottom: 24px;
    .title {
      h5 {
        font-size: 13px;
        margin-bottom: 6px;
      }
    }
    .sub-title {
      h3 {
        font-size: 32px;
        margin-bottom: 30px;
      }
    }
  }

  .content-wrapper {
    display: flex;
    gap: 20px;

    .left-content {
      width: 50%;
      .completion-card {
        background-color: #fff1c0;
        padding: 30px 20px;
        border-radius: 10px;

        .card-content-wrapper {
          display: flex;
          gap: 20px;

          .avatar {
            svg {
              height: 95px;
              width: 95px;
            }
          }
          .content {
            font-size: 14px;
            line-height: 20px;

            h1 {
              font-size: 24px;
              line-height: 30px;
              margin-bottom: 13px;
            }

            .date {
              margin-bottom: 10px;
              div {
                &:first-child {
                  margin-bottom: 8px;
                }
              }
            }

            .description {
              a {
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
    .right-content {
      width: 50%;

      .certification-img {
        width: 100%;
        height: auto;
      }
    }
  }
}
@media (max-width: 475px) {
  .accomplishment-section {
    margin: 12px 0;
    .title-wrapper {
      margin-bottom: 16px;
      .title {
        h5 {
          font-size: 10px;
          margin-bottom: 4px;
        }
      }
      .sub-title {
        h3 {
          font-size: 13px;
          margin-bottom: 8px;
        }
      }
    }

    .content-wrapper {
      flex-direction: column;
      gap: 25px;

      .left-content {
        width: 100%;
        .completion-card {
          padding: 16px 8px;

          .card-content-wrapper {
            gap: 14px;

            .avatar {
              svg {
                height: 70px;
                width: 70px;
              }
            }
            .content {
              font-size: 11px;
              line-height: 14px;

              h1 {
                font-size: 14px;
                line-height: 18px;
                margin-bottom: 8px;
              }

              .date {
                margin-bottom: 6px;
                div {
                  &:first-child {
                    margin-bottom: 4px;
                  }
                }
              }

              .description {
                a {
                  text-decoration: underline;
                }
              }
            }
          }
        }
      }
      .right-content {
        width: 100%;

        .certification-img {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>
